var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DatePicker',{ref:_vm.refId,staticClass:"datepicker",attrs:{"lang":_vm.lang,"type":_vm.type,"valueType":"format","format":_vm.format,"input-class":"form_control","placeholder":_vm.placeholder,"disabled":_vm.disabled,"value":_vm.defaultDate},on:{"change":_vm.fn_change}})
}
var staticRenderFns = []

export { render, staticRenderFns }